module.exports = __webpack_public_path__ + "static/media/AOFAS-Hallux-Scale.e3bc839d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/AOFAS-Hallux-Scale.pdf
// module id = 286
// module chunks = 0